import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Filter, Map, List } from "react-feather";
import Select from "react-select";
import FadeLoader from "react-spinners/FadeLoader";
import LoadingOverlay from "react-loading-overlay";
import { Checkbox } from "react-icheck";

import ListingCard from "../components/ListingCard";
import MapWithMarkers from "../components/MapWithMarkers";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import PlacesSearchFilter from "../components/PlacesSearchFilter";
import { classnames } from "../places_api_utils";
import { Modal } from "react-bootstrap";

const styles = theme => ({
  modalContent: {
    border: "0px",
    maxHeight: "100vh"
  },
  rangeInput: {
    maxWidth: "45%",
    flex: "0 0 45%"
  }
});

class MobileSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredListingId: null,
      address: null,
      showSearchModal: false,
      mapSize: { size: { height: "1000px", width: "1000px" } }

    };
  }

  componentDidMount() {
    this.setState({ address: this.props.listingFilter.searchStr });
  }

  handleMarkerClick = mlsNumber => {
    this.setState({
      hoveredListingId: mlsNumber
    });
  };

  handleListingEnter = listing => {
    this.setState({
      hoveredListingId: listing.mlsNumber
    });
  };

  handlingListingLeave = () => {
    this.setState({
      hoveredListingId: null
    });
  };

  setMapSize = mapSize => {
    this.setState({ mapSize });
  };

  submitForm = data => {
    console.log(data);
  };

  render() {
    const {
      classes,
      updateFilter,
      clearFilter,
      listingFilter,
      listings,
      toggleMapShowing,
      mapShowing,
      handleSearch,
      handleChange,
      isLoading,
      searchId
    } = this.props;

    const poolOptions = [
      { value: "INGRD", label: "Inground Pool" },
      { value: "NBRHD", label: "Neighborhood" },
      { value: "ABVGR", label: "Above ground Pool" }
    ];

    const getPoolValues = selections => {
      if (!selections) return "";

      const selected = selections.map(s =>
        poolOptions.find(p => p.value === s)
      );
      return selected;
    };
    const loadingSpinner = (
      <FadeLoader sizeUnit="px" size={300} color="#4A90E2" />
    );

    const handleStatusChange = (e, checked, statusType) => {
      const prevStatus = listingFilter.status && listingFilter.status.slice();

      const isCurrentlySelected =
        prevStatus && prevStatus.indexOf(statusType) > -1;

      if (checked && !isCurrentlySelected) {
        prevStatus.push(statusType);
        updateFilter({ status: prevStatus });
      }
      if (!checked && isCurrentlySelected) {
        updateFilter({ status: prevStatus.filter(s => s !== statusType) });
      }
    };

    const handleSearchStrChange = address => {
      this.setState({ address, suggestion: null });
    };

    const onSuggestionClick = suggestion => {
      this.setState({
        suggestion: suggestion,
        address: suggestion.formattedSuggestion.mainText
      });
      geocodeByAddress(suggestion.description)
        //.then(results => getLatLng(results[0]))
        .then(results => results[0])
        .then(result => {
          const address_components = result.address_components;
          const searchLocType =
            address_components &&
            address_components[0] &&
            address_components[0].types[0];
          const searchLoc = {};

          updateFilter({
            searchStr: suggestion.description,
            searchLocType: searchLocType,
            searchLoc: searchLoc
          });
        });
    };

    const handleSelect = address => {
      console.log("test");
    };

    const defaultBounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(33.419497251637985, -91.75625559120783),
      new window.google.maps.LatLng(36.84355854152846, -88.34170460879216)
    );

    const location = new window.google.maps.LatLng(
      35.39032338025625,
      -89.26065817950166
    );

    const searchOptions = {
      location: location,
      radius: 200,
      //'types': ['geocode', 'address', '(regions)', '(cities)'],
      bounds: defaultBounds,
      componentRestrictions: { country: "us" },
      strictBounds: true
    };

    const hasListings = listings.length > 0;

    const handleClose = () => {
      this.setState({
        showSearchModal: false
      });
    };

    const handleShow = () => {
      this.setState({
        showSearchModal: true
      });
    };

    return (
      <LoadingOverlay active={isLoading} spinner={loadingSpinner}>
        <div className="mobile-search">
          {!this.state.showSearchModal && (
            <div className="mobile-search-filter-bar">
              <div className="d-flex">
                <div className="" style={{ padding: ".375rem 0 .375rem 0" }}>
                  Viewing {listings.length} listings
                </div>
                <div className="ml-auto">
                  {!mapShowing && hasListings && (
                    <select
                      className="custom-select mr-sm-2 float-right"
                      value={listingFilter.sort}
                      onChange={e => updateFilter({ sort: e.target.value })}
                    >
                      <option value="price-desc">Price High to Low</option>
                      <option value="price-asc">Price Low to High</option>
                      <option value="daysOnMarket-asc">Newest to Oldest</option>
                      <option value="daysOnMarket-desc">
                        Oldest to Newest
                      </option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="mobile-content">
            {!mapShowing && (
              <div className={`listView${mapShowing ? " d-none" : ""}`}>
                {!hasListings && (
                  <div className="pt-5">
                    <b>Refine your search to find properties</b>
                  </div>
                )}
                <div className="listing-cards">
                  <div className="cards-wrapper" section="GridView">
                    <div className="cards">
                      {listings.map(listing => (
                        <ListingCard
                          listing={listing}
                          openInNewWindow={false}
                          handleListingEnter={this.handleListingEnter}
                          handleListingLeave={() =>
                            this.handlingListingLeave(listing.mlsNumber)
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {mapShowing && (
              <MapWithMarkers
                listings={listings}
                listingFilter={listingFilter}
                updateFilter={updateFilter}
              />
            )}
          </div>
          <div className="mobile-search-footer">
            <div className="row">
              <div className="col text-center">
                <button
                  type="button"
                  className="btn btn-link"
                  // data-toggle="modal"
                  // data-target="#filterModal"
                  onClick={handleShow}
                >
                  <Filter />
                  <br />
                  Advanced Search
                </button>
              </div>
              <div className="col text-center">
                <button
                  id="mapViewToggle"
                  type="button"
                  className={`btn btn-link viewToggle ${
                    mapShowing ? " d-none" : ""
                  }`}
                  onClick={() => toggleMapShowing()}
                >
                  <Map />
                  <br />
                  Map
                </button>
                <button
                  id="listViewToggle"
                  type="button"
                  className={`btn btn-link viewToggle ${
                    !mapShowing ? " d-none" : ""
                  }`}
                  onClick={() => toggleMapShowing()}
                >
                  <List />
                  <br />
                  List
                </button>
              </div>
            </div>
          </div>

          <Modal
            show={this.state.showSearchModal}
            onHide={handleClose}
            dialogClassName="modal-full modal-dialog-scrollable"
          >
            <Modal.Body>
              <div className="search-body">
                <div className="advanced-search-panel">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    style={{ zIndex: "1090" }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>

                  <div style={{ width: "100%" }}>
                    <div className="container-fluid">
                      <div className="row" style={{ paddingTop: "4em" }}>
                        <div className="col-12">
                          <div className="row">
                            <div className="col-12">
                              <PlacesSearchFilter
                                listingFilter={listingFilter}
                                updateFilter={updateFilter}
                                searchId={searchId}
                              ></PlacesSearchFilter>
                            </div>
                          </div>
                          <div className="rangeSelections row">
                            <div className="col-6">
                              <div
                                className="text-left"
                                style={{ paddingLeft: "0px" }}
                              >
                                Beds
                              </div>
                              <select
                                className="select custom-select range-select col-12"
                                name="beds"
                                value={listingFilter.beds || ""}
                                onChange={event =>
                                  updateFilter({ beds: event.target.value })
                                }
                              >
                                <option>Any</option>
                                <option value="1">1+</option>
                                <option value="2">2+</option>
                                <option value="3">3+</option>
                                <option value="4">4+</option>
                                <option value="5">5+</option>
                              </select>
                            </div>
                            <div className="col-6">
                              <div className="text-left">Baths</div>
                              <select
                                name="baths"
                                className="select custom-select range-select "
                                value={listingFilter.baths || ""}
                                onChange={event =>
                                  updateFilter({
                                    baths: event.target.value
                                  })
                                }
                              >
                                <option>Any</option>
                                <option value="1">1+</option>
                                <option value="2">2+</option>
                                <option value="3">3+</option>
                                <option value="4">4+</option>
                                <option value="5">5+</option>
                              </select>
                            </div>
                          </div>

                          <div className="rangeSelections row pt-2">
                            <div className="col-12 text-left">Price</div>
                            <div className="col-12">
                              <select
                                name="priceMin"
                                className={`${classes.rangeInput} select custom-select range-select col-5`}
                                value={listingFilter.priceMin || ""}
                                onChange={event =>
                                  updateFilter({
                                    priceMin: event.target.value
                                  })
                                }
                              >
                                <option value="">No Min</option>
                                <option value="10000">$10K</option>
                                <option value="20000">$20K</option>
                                <option value="25000">$25K</option>
                                <option value="30000">$30K</option>
                                <option value="40000">$40K</option>
                                <option value="50000">$50K</option>
                                <option value="60000">$60K</option>
                                <option value="70000">$70K</option>
                                <option value="75000">$75K</option>
                                <option value="80000">$80K</option>
                                <option value="90000">$90K</option>
                                <option value="100000">$100K</option>
                                <option value="110000">$110K</option>
                                <option value="120000">$120K</option>
                                <option value="125000">$125K</option>
                                <option value="130000">$130K</option>
                                <option value="140000">$140K</option>
                                <option value="150000">$150K</option>
                                <option value="160000">$160K</option>
                                <option value="170000">$170K</option>
                                <option value="175000">$175K</option>
                                <option value="180000">$180K</option>
                                <option value="190000">$190K</option>
                                <option value="200000">$200K</option>
                                <option value="210000">$210K</option>
                                <option value="220000">$220K</option>
                                <option value="230000">$230K</option>
                                <option value="240000">$240K</option>
                                <option value="250000">$250K</option>
                                <option value="275000">$275K</option>
                                <option value="300000">$300K</option>
                                <option value="325000">$325K</option>
                                <option value="350000">$350K</option>
                                <option value="375000">$375K</option>
                                <option value="400000">$400K</option>
                                <option value="425000">$425K</option>
                                <option value="450000">$450K</option>
                                <option value="475000">$475K</option>
                                <option value="500000">$500K</option>
                                <option value="525000">$525K</option>
                                <option value="550000">$550K</option>
                                <option value="575000">$575K</option>
                                <option value="600000">$600K</option>
                                <option value="625000">$625K</option>
                                <option value="650000">$650K</option>
                                <option value="675000">$675K</option>
                                <option value="700000">$700K</option>
                                <option value="725000">$725K</option>
                                <option value="750000">$750K</option>
                                <option value="775000">$775K</option>
                                <option value="800000">$800K</option>
                                <option value="825000">$825K</option>
                                <option value="850000">$850K</option>
                                <option value="875000">$875K</option>
                                <option value="900000">$900K</option>
                                <option value="925000">$925K</option>
                                <option value="950000">$950K</option>
                                <option value="975000">$975K</option>
                                <option value="1000000">$1M</option>
                                <option value="1100000">$1.1M</option>
                                <option value="1200000">$1.2M</option>
                                <option value="1300000">$1.3M</option>
                                <option value="1400000">$1.4M</option>
                                <option value="1500000">$1.5M</option>
                                <option value="1600000">$1.6M</option>
                                <option value="1700000">$1.7M</option>
                                <option value="1800000">$1.8M</option>
                                <option value="1900000">$1.9M</option>
                                <option value="2000000">$2M</option>
                                <option value="2250000">$2.25M</option>
                                <option value="2500000">$2.5M</option>
                                <option value="2750000">$2.75M</option>
                                <option value="3000000">$3M</option>
                                <option value="3500000">$3.5M</option>
                                <option value="4000000">$4M</option>
                                <option value="4500000">$4.5M</option>
                                <option value="5000000">$5M</option>
                              </select>
                              <span className="separator">to</span>
                              <select
                                name="priceMax"
                                className={`${classes.rangeInput} select custom-select range-select col-5`}
                                value={listingFilter.priceMax || ""}
                                onChange={event =>
                                  updateFilter({
                                    priceMax: event.target.value
                                  })
                                }
                              >
                                <option value="">No Max</option>
                                <option value="90000">$90K</option>
                                <option value="100000">$100K</option>
                                <option value="110000">$110K</option>
                                <option value="120000">$120K</option>
                                <option value="125000">$125K</option>
                                <option value="130000">$130K</option>
                                <option value="140000">$140K</option>
                                <option value="150000">$150K</option>
                                <option value="160000">$160K</option>
                                <option value="170000">$170K</option>
                                <option value="175000">$175K</option>
                                <option value="180000">$180K</option>
                                <option value="190000">$190K</option>
                                <option value="200000">$200K</option>
                                <option value="210000">$210K</option>
                                <option value="220000">$220K</option>
                                <option value="230000">$230K</option>
                                <option value="240000">$240K</option>
                                <option value="250000">$250K</option>
                                <option value="275000">$275K</option>
                                <option value="300000">$300K</option>
                                <option value="325000">$325K</option>
                                <option value="350000">$350K</option>
                                <option value="375000">$375K</option>
                                <option value="400000">$400K</option>
                                <option value="425000">$425K</option>
                                <option value="450000">$450K</option>
                                <option value="475000">$475K</option>
                                <option value="500000">$500K</option>
                                <option value="525000">$525K</option>
                                <option value="550000">$550K</option>
                                <option value="575000">$575K</option>
                                <option value="600000">$600K</option>
                                <option value="625000">$625K</option>
                                <option value="650000">$650K</option>
                                <option value="675000">$675K</option>
                                <option value="700000">$700K</option>
                                <option value="725000">$725K</option>
                                <option value="750000">$750K</option>
                                <option value="775000">$775K</option>
                                <option value="800000">$800K</option>
                                <option value="825000">$825K</option>
                                <option value="850000">$850K</option>
                                <option value="875000">$875K</option>
                                <option value="900000">$900K</option>
                                <option value="925000">$925K</option>
                                <option value="950000">$950K</option>
                                <option value="975000">$975K</option>
                                <option value="1000000">$1M</option>
                                <option value="1100000">$1.1M</option>
                                <option value="1200000">$1.2M</option>
                                <option value="1300000">$1.3M</option>
                                <option value="1400000">$1.4M</option>
                                <option value="1500000">$1.5M</option>
                                <option value="1600000">$1.6M</option>
                                <option value="1700000">$1.7M</option>
                                <option value="1800000">$1.8M</option>
                                <option value="1900000">$1.9M</option>
                                <option value="2000000">$2M</option>
                                <option value="2250000">$2.25M</option>
                                <option value="2500000">$2.5M</option>
                                <option value="2750000">$2.75M</option>
                                <option value="3000000">$3M</option>
                                <option value="3500000">$3.5M</option>
                                <option value="4000000">$4M</option>
                                <option value="4500000">$4.5M</option>
                                <option value="5000000">$5M</option>
                              </select>
                            </div>
                          </div>

                          <div className="rangeSelections row pt-2">
                            <div className="col-12 text-left">Square Ft</div>
                            <div className="col-12">
                              <select
                                name="sqftMin"
                                className={`${classes.rangeInput} select custom-select range-select col-5`}
                                value={listingFilter.sqftMin || ""}
                                onChange={event =>
                                  updateFilter({
                                    sqftMin: event.target.value
                                  })
                                }
                              >
                                <option value="0">No Min</option>
                                <option value="500">500 sqft</option>
                                <option value="750">750 sqft</option>
                                <option value="1000">1,000 sqft</option>
                                <option value="1250">1,250 sqft</option>
                                <option value="1500">1,500 sqft</option>
                                <option value="1750">1,750 sqft</option>
                                <option value="2000">2,000 sqft</option>
                                <option value="2250">2,250 sqft</option>
                                <option value="2500">2,500 sqft</option>
                                <option value="2750">2,750 sqft</option>
                                <option value="3000">3,000 sqft</option>
                                <option value="3250">3,250 sqft</option>
                                <option value="3500">3,500 sqft</option>
                                <option value="3750">3,750 sqft</option>
                                <option value="5000">5,000 sqft</option>
                                <option value="7500">7,500 sqft</option>
                              </select>
                              <span className="separator">to</span>
                              <select
                                name="sqftMax"
                                className={`${classes.rangeInput} select custom-select range-select col-5`}
                                value={listingFilter.sqftMax || ""}
                                onChange={event =>
                                  updateFilter({
                                    sqftMax: event.target.value
                                  })
                                }
                              >
                                <option value="0">No Max</option>
                                <option value="750">750 sqft</option>
                                <option value="1000">1,000 sqft</option>
                                <option value="1250">1,250 sqft</option>
                                <option value="1500">1,500 sqft</option>
                                <option value="1750">1,750 sqft</option>
                                <option value="2000">2,000 sqft</option>
                                <option value="2250">2,250 sqft</option>
                                <option value="2500">2,500 sqft</option>
                                <option value="2750">2,750 sqft</option>
                                <option value="3000">3,000 sqft</option>
                                <option value="3250">3,250 sqft</option>
                                <option value="3500">3,500 sqft</option>
                                <option value="3750">3,750 sqft</option>
                                <option value="5000">5,000 sqft</option>
                                <option value="7500">7,500 sqft</option>
                              </select>
                            </div>
                          </div>
                          <div className="rangeSelections row pt-2">
                            <div className="col-12 text-left">Year Built</div>
                            <div className="col-12">
                              <input
                                name="yearMin"
                                className={`${classes.rangeInput} form-control col-5 d-inline`}
                                value={listingFilter.yearMin || ""}
                                onChange={e =>
                                  handleChange(e.target.value, "yearMin")
                                }
                                onBlur={event =>
                                  updateFilter({
                                    yearMin: event.target.value
                                  })
                                }
                              />
                              <span className="separator">to</span>
                              <input
                                name="yearMax"
                                className={`${classes.rangeInput} form-control col-5 d-inline`}
                                value={listingFilter.yearMax || ""}
                                onChange={e =>
                                  handleChange(e.target.value, "yearMax")
                                }
                                onBlur={event =>
                                  updateFilter({
                                    yearMax: event.target.value
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="rangeSelections row pt-2">
                            <div className="col-12 text-left">Acreage</div>
                            <div className="col-12">
                              <input
                                name="acreageMin"
                                className={`${classes.rangeInput} form-control col-5 d-inline`}
                                value={listingFilter.acreageMin || ""}
                                onChange={e =>
                                  handleChange(e.target.value, "acreageMin")
                                }
                                onBlur={event =>
                                  updateFilter({
                                    acreageMin: event.target.value
                                  })
                                }
                              />
                              <span className="separator">to</span>
                              <input
                                name="acreageMax"
                                className={`${classes.rangeInput} form-control col-5 d-inline`}
                                value={listingFilter.acreageMax || ""}
                                onChange={e =>
                                  handleChange(e.target.value, "acreageMax")
                                }
                                onBlur={event =>
                                  updateFilter({
                                    acreageMax: event.target.value
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="row pt-2 rangeSelections">
                            <div className="col-12 text-left">Neighborhood</div>
                            <div className="col-12">
                              <select
                                name="MLSAreas"
                                className="select custom-select range-select col-10"
                                value={listingFilter.MLSAreas}
                                onChange={event =>
                                  updateFilter({
                                    MLSAreas: event.target.value
                                  })
                                }
                              >
                                <option value="">Any</option>
                                <option value="94,95,96">Arlington</option>
                                <option value="94">Arlington Reserve</option>
                                <option value="97,98,99,100,101,102">
                                  Bartlett
                                </option>
                                <option value="102,99,97">
                                  Bartlett Reserve
                                </option>
                                <option value="74,75,76,77,78,79,80,81,82">
                                  Cordova
                                </option>
                                <option value="107,108,109,110,111,112">
                                  Collierville
                                </option>
                                <option value="107,72,24">
                                  Collierville Reserve
                                </option>
                                <option value="36,40,42">Downtown</option>
                                <option value="47,48,49,50,51,52,44,45,46,65,66,67">
                                  East Memphis
                                </option>
                                <option value="24,25,26,27,28,29,30">
                                  Frayser
                                </option>
                                <option value="103,104,105,106,71,67,65">
                                  Germantown
                                </option>
                                <option value="91,92,93">Lakeland</option>
                                <option value="92">Lakeland Reserve</option>
                                <option value="37,38,39,41,43">Midtown</option>
                                <option value="83,84,85,86,87,88,89,90">
                                  Millington
                                </option>
                                <option value="31,32,33,34,35">Raleigh</option>
                                <option value="113,8,9,10,11,12,13,14,15,5,1,2,3,4,6,7,16,17,18,19,20,21,22,23">
                                  Rural
                                </option>
                                <option value="72,68,69,70,71,73,61,62,63,64">
                                  Southwind
                                </option>
                                <option value="53,54,55,56,57,58,59,60">
                                  Whitehaven
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="row pt-2 rangeSelections">
                            <div className="col-12 text-left">Pool</div>
                            <div className="col-12">
                              <select
                                name="pool"
                                className="select custom-select range-select col-10"
                                value={listingFilter.pool}
                                onChange={event =>
                                  updateFilter({ pool: event.target.value })
                                }
                              >
                                <option value="">Any</option>
                                <option value="NBRHD">Neighborhood</option>
                                <option value="INGRD">Inground</option>
                                <option value="ABVGR">Above Ground</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-check form-check-inline pt-2 justify-content-start d-block">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" New Construction"
                              checked={listingFilter.newConstruction}
                              onChange={(e, checked) =>
                                updateFilter({
                                  newConstruction: checked ? 1 : 0
                                })
                              }
                            />
                          </div>
                          <div className="form-check form-check-inline pt-2 justify-content-start">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" Guest House/In-Law Quarters"
                              checked={listingFilter.guestHouse}
                              onChange={(e, checked) =>
                                updateFilter({
                                  guestHouse: checked ? 1 : 0
                                })
                              }
                            />
                          </div>
                          <div className="form-check form-check-inline col pt-2 justify-content-start">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" Hobson Listings Only"
                              checked={listingFilter.hobsonOnly}
                              onChange={(e, checked) =>
                                updateFilter({
                                  hobsonOnly: checked ? 1 : 0
                                })
                              }
                            />
                          </div>
                          <div className="form-check form-check-inline col pt-2 justify-content-start">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" Master Bed Down"
                              checked={listingFilter.masterBedDown}
                              onChange={(e, checked) =>
                                updateFilter({
                                  masterBedDown: checked ? 1 : 0
                                })
                              }
                            />
                          </div>
                          <div className="form-check form-check-inline col pt-2 justify-content-start">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" Has Open House"
                              checked={listingFilter.hasOpenHouse}
                              onChange={(e, checked) =>
                                updateFilter({
                                  hasOpenHouse: checked ? 1 : 0
                                })
                              }
                            />
                          </div>
                          <div className="form-check form-check-inline col pt-2 justify-content-start">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" Condo"
                              checked={listingFilter.condosOnly}
                              onChange={(e, checked) =>
                                updateFilter({
                                  condosOnly: checked ? 1 : 0
                                })
                              }
                            />
                          </div>
                          <div className="form-check form-check-inline col pt-2 justify-content-start">
                            <Checkbox
                              checkboxClass="icheckbox_flat-blue"
                              increaseArea="20%"
                              label=" Zero Lot Line"
                              checked={listingFilter.isZeroLotLine}
                              onChange={(e, checked) =>
                                updateFilter({
                                  isZeroLotLine: checked ? 1 : 0
                                })
                              }
                            />
                          </div>

                          <div
                            className="col-12 pt-2"
                            style={{ paddingLeft: "0" }}
                          >
                            <label
                              htmlFor="daysOnMarket"
                              className="col-form-label col-xl-3 col-md-5 pl-0 pr-0"
                            >
                              Days on Market
                              <select
                                id="daysOnMarket"
                                name="daysOnMarket"
                                className="select custom-select col-8"
                                style={{ display: "block" }}
                                value={listingFilter.daysOnMarketStr}
                                onChange={event =>
                                  updateFilter({
                                    daysOnMarketStr: event.target.value
                                  })
                                }
                              >
                                <option value="">Any</option>
                                <option value="24h">Last 24 hours</option>
                                <option value="1w">Within last week</option>
                                <option value="1m">Within last month</option>
                                <option value="3m">Within last 3 month</option>
                                <option value="46m">4 to 6 months</option>
                                <option value="6m">6+ months</option>
                              </select>
                            </label>
                          </div>
                          <div className="col-12" style={{ paddingLeft: "0" }}>
                            <label
                              htmlFor="coveredParking"
                              className="col-form-label col-sm-6 col-xl-3 col-md-4 pl-0 pr-0"
                            >
                              Covered Parking
                              <select
                                id="coveredParking"
                                className="custom-select mr-sm-2 col-4"
                                style={{ width: "100%", display: "block" }}
                                name="coveredParking"
                                value={listingFilter.coveredParking}
                                onChange={event =>
                                  updateFilter({
                                    coveredParking: event.target.value
                                  })
                                }
                              >
                                <option>Any</option>
                                <option value="1">1+</option>
                                <option value="2">2+</option>
                                <option value="3">3+</option>
                                <option value="4">4+</option>
                              </select>
                            </label>
                          </div>
                          <div className="col-12" style={{ paddingLeft: "0" }}>
                            <label className="col-form-label col-sm-6 col-xl-3 col-md-4 pl-0 pr-0">
                              Status
                            </label>
                            <div className="col-12 px-2">
                              <div className="form-check form-check-inline">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Active"
                                  checked={
                                    listingFilter.status &&
                                    listingFilter.status.indexOf("ACT") > -1
                                  }
                                  onChange={(e, checked) =>
                                    handleStatusChange(e, checked, "ACT")
                                  }
                                />
                              </div>
                              <div className="form-check form-check-inline">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Contingent"
                                  checked={
                                    listingFilter.status &&
                                    listingFilter.status.indexOf("CNTG") > -1
                                  }
                                  onChange={(e, checked) =>
                                    handleStatusChange(e, checked, "CNTG")
                                  }
                                />
                              </div>
                              <div className="form-check form-check-inline">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Pending"
                                  checked={
                                    listingFilter.status &&
                                    listingFilter.status.indexOf("PEND") > -1
                                  }
                                  onChange={(e, checked) =>
                                    handleStatusChange(e, checked, "PEND")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="col-12 pt-2">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={handleClose}
                >
                  View {listings.length} Listings
                </button>
                <button
                  type="button"
                  className="btn btn-danger w-100 mt-2"
                  onClick={() => clearFilter()}
                  data-dismiss="modal"
                >
                  Clear Filters
                </button>
              </div>
            </Modal.Footer>
          </Modal>

          <div
            className="modal modal-full"
            id="filterModal"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-scrollable"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-body">
                  <div className="search-body">
                    <div className="advanced-search-panel">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{ zIndex: "1090" }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>

                      <div style={{ width: "100%" }}>
                        <div className="container-fluid">
                          <div className="row" style={{ paddingTop: "4em" }}>
                            <div className="col-12">
                              <div className="row">
                                <div className="col-12">
                                  <PlacesSearchFilter
                                    listingFilter={listingFilter}
                                    updateFilter={updateFilter}
                                    searchId={searchId}
                                  ></PlacesSearchFilter>
                                </div>
                              </div>
                              <div className="rangeSelections row">
                                <div className="col-6">
                                  <div
                                    className="text-left"
                                    style={{ paddingLeft: "0px" }}
                                  >
                                    Beds
                                  </div>
                                  <select
                                    className="select custom-select range-select col-12"
                                    name="beds"
                                    value={listingFilter.beds || ""}
                                    onChange={event =>
                                      updateFilter({ beds: event.target.value })
                                    }
                                  >
                                    <option>Any</option>
                                    <option value="1">1+</option>
                                    <option value="2">2+</option>
                                    <option value="3">3+</option>
                                    <option value="4">4+</option>
                                    <option value="5">5+</option>
                                  </select>
                                </div>
                                <div className="col-6">
                                  <div className="text-left">Baths</div>
                                  <select
                                    name="baths"
                                    className="select custom-select range-select "
                                    value={listingFilter.baths || ""}
                                    onChange={event =>
                                      updateFilter({
                                        baths: event.target.value
                                      })
                                    }
                                  >
                                    <option>Any</option>
                                    <option value="1">1+</option>
                                    <option value="2">2+</option>
                                    <option value="3">3+</option>
                                    <option value="4">4+</option>
                                    <option value="5">5+</option>
                                  </select>
                                </div>
                              </div>

                              <div className="rangeSelections row pt-2">
                                <div className="col-12 text-left">Price</div>
                                <div className="col-12">
                                  <select
                                    name="priceMin"
                                    className={`${classes.rangeInput} select custom-select range-select col-5`}
                                    value={listingFilter.priceMin || ""}
                                    onChange={event =>
                                      updateFilter({
                                        priceMin: event.target.value
                                      })
                                    }
                                  >
                                    <option value="">No Min</option>
                                    <option value="10000">$10K</option>
                                    <option value="20000">$20K</option>
                                    <option value="25000">$25K</option>
                                    <option value="30000">$30K</option>
                                    <option value="40000">$40K</option>
                                    <option value="50000">$50K</option>
                                    <option value="60000">$60K</option>
                                    <option value="70000">$70K</option>
                                    <option value="75000">$75K</option>
                                    <option value="80000">$80K</option>
                                    <option value="90000">$90K</option>
                                    <option value="100000">$100K</option>
                                    <option value="110000">$110K</option>
                                    <option value="120000">$120K</option>
                                    <option value="125000">$125K</option>
                                    <option value="130000">$130K</option>
                                    <option value="140000">$140K</option>
                                    <option value="150000">$150K</option>
                                    <option value="160000">$160K</option>
                                    <option value="170000">$170K</option>
                                    <option value="175000">$175K</option>
                                    <option value="180000">$180K</option>
                                    <option value="190000">$190K</option>
                                    <option value="200000">$200K</option>
                                    <option value="210000">$210K</option>
                                    <option value="220000">$220K</option>
                                    <option value="230000">$230K</option>
                                    <option value="240000">$240K</option>
                                    <option value="250000">$250K</option>
                                    <option value="275000">$275K</option>
                                    <option value="300000">$300K</option>
                                    <option value="325000">$325K</option>
                                    <option value="350000">$350K</option>
                                    <option value="375000">$375K</option>
                                    <option value="400000">$400K</option>
                                    <option value="425000">$425K</option>
                                    <option value="450000">$450K</option>
                                    <option value="475000">$475K</option>
                                    <option value="500000">$500K</option>
                                    <option value="525000">$525K</option>
                                    <option value="550000">$550K</option>
                                    <option value="575000">$575K</option>
                                    <option value="600000">$600K</option>
                                    <option value="625000">$625K</option>
                                    <option value="650000">$650K</option>
                                    <option value="675000">$675K</option>
                                    <option value="700000">$700K</option>
                                    <option value="725000">$725K</option>
                                    <option value="750000">$750K</option>
                                    <option value="775000">$775K</option>
                                    <option value="800000">$800K</option>
                                    <option value="825000">$825K</option>
                                    <option value="850000">$850K</option>
                                    <option value="875000">$875K</option>
                                    <option value="900000">$900K</option>
                                    <option value="925000">$925K</option>
                                    <option value="950000">$950K</option>
                                    <option value="975000">$975K</option>
                                    <option value="1000000">$1M</option>
                                    <option value="1100000">$1.1M</option>
                                    <option value="1200000">$1.2M</option>
                                    <option value="1300000">$1.3M</option>
                                    <option value="1400000">$1.4M</option>
                                    <option value="1500000">$1.5M</option>
                                    <option value="1600000">$1.6M</option>
                                    <option value="1700000">$1.7M</option>
                                    <option value="1800000">$1.8M</option>
                                    <option value="1900000">$1.9M</option>
                                    <option value="2000000">$2M</option>
                                    <option value="2250000">$2.25M</option>
                                    <option value="2500000">$2.5M</option>
                                    <option value="2750000">$2.75M</option>
                                    <option value="3000000">$3M</option>
                                    <option value="3500000">$3.5M</option>
                                    <option value="4000000">$4M</option>
                                    <option value="4500000">$4.5M</option>
                                    <option value="5000000">$5M</option>
                                  </select>
                                  <span className="separator">to</span>
                                  <select
                                    name="priceMax"
                                    className={`${classes.rangeInput} select custom-select range-select col-5`}
                                    value={listingFilter.priceMax || ""}
                                    onChange={event =>
                                      updateFilter({
                                        priceMax: event.target.value
                                      })
                                    }
                                  >
                                    <option value="">No Max</option>
                                    <option value="90000">$90K</option>
                                    <option value="100000">$100K</option>
                                    <option value="110000">$110K</option>
                                    <option value="120000">$120K</option>
                                    <option value="125000">$125K</option>
                                    <option value="130000">$130K</option>
                                    <option value="140000">$140K</option>
                                    <option value="150000">$150K</option>
                                    <option value="160000">$160K</option>
                                    <option value="170000">$170K</option>
                                    <option value="175000">$175K</option>
                                    <option value="180000">$180K</option>
                                    <option value="190000">$190K</option>
                                    <option value="200000">$200K</option>
                                    <option value="210000">$210K</option>
                                    <option value="220000">$220K</option>
                                    <option value="230000">$230K</option>
                                    <option value="240000">$240K</option>
                                    <option value="250000">$250K</option>
                                    <option value="275000">$275K</option>
                                    <option value="300000">$300K</option>
                                    <option value="325000">$325K</option>
                                    <option value="350000">$350K</option>
                                    <option value="375000">$375K</option>
                                    <option value="400000">$400K</option>
                                    <option value="425000">$425K</option>
                                    <option value="450000">$450K</option>
                                    <option value="475000">$475K</option>
                                    <option value="500000">$500K</option>
                                    <option value="525000">$525K</option>
                                    <option value="550000">$550K</option>
                                    <option value="575000">$575K</option>
                                    <option value="600000">$600K</option>
                                    <option value="625000">$625K</option>
                                    <option value="650000">$650K</option>
                                    <option value="675000">$675K</option>
                                    <option value="700000">$700K</option>
                                    <option value="725000">$725K</option>
                                    <option value="750000">$750K</option>
                                    <option value="775000">$775K</option>
                                    <option value="800000">$800K</option>
                                    <option value="825000">$825K</option>
                                    <option value="850000">$850K</option>
                                    <option value="875000">$875K</option>
                                    <option value="900000">$900K</option>
                                    <option value="925000">$925K</option>
                                    <option value="950000">$950K</option>
                                    <option value="975000">$975K</option>
                                    <option value="1000000">$1M</option>
                                    <option value="1100000">$1.1M</option>
                                    <option value="1200000">$1.2M</option>
                                    <option value="1300000">$1.3M</option>
                                    <option value="1400000">$1.4M</option>
                                    <option value="1500000">$1.5M</option>
                                    <option value="1600000">$1.6M</option>
                                    <option value="1700000">$1.7M</option>
                                    <option value="1800000">$1.8M</option>
                                    <option value="1900000">$1.9M</option>
                                    <option value="2000000">$2M</option>
                                    <option value="2250000">$2.25M</option>
                                    <option value="2500000">$2.5M</option>
                                    <option value="2750000">$2.75M</option>
                                    <option value="3000000">$3M</option>
                                    <option value="3500000">$3.5M</option>
                                    <option value="4000000">$4M</option>
                                    <option value="4500000">$4.5M</option>
                                    <option value="5000000">$5M</option>
                                  </select>
                                </div>
                              </div>

                              <div className="rangeSelections row pt-2">
                                <div className="col-12 text-left">
                                  Square Ft
                                </div>
                                <div className="col-12">
                                  <select
                                    name="sqftMin"
                                    className={`${classes.rangeInput} select custom-select range-select col-5`}
                                    value={listingFilter.sqftMin || ""}
                                    onChange={event =>
                                      updateFilter({
                                        sqftMin: event.target.value
                                      })
                                    }
                                  >
                                    <option value="0">No Min</option>
                                    <option value="500">500 sqft</option>
                                    <option value="750">750 sqft</option>
                                    <option value="1000">1,000 sqft</option>
                                    <option value="1250">1,250 sqft</option>
                                    <option value="1500">1,500 sqft</option>
                                    <option value="1750">1,750 sqft</option>
                                    <option value="2000">2,000 sqft</option>
                                    <option value="2250">2,250 sqft</option>
                                    <option value="2500">2,500 sqft</option>
                                    <option value="2750">2,750 sqft</option>
                                    <option value="3000">3,000 sqft</option>
                                    <option value="3250">3,250 sqft</option>
                                    <option value="3500">3,500 sqft</option>
                                    <option value="3750">3,750 sqft</option>
                                    <option value="5000">5,000 sqft</option>
                                    <option value="7500">7,500 sqft</option>
                                  </select>
                                  <span className="separator">to</span>
                                  <select
                                    name="sqftMax"
                                    className={`${classes.rangeInput} select custom-select range-select col-5`}
                                    value={listingFilter.sqftMax || ""}
                                    onChange={event =>
                                      updateFilter({
                                        sqftMax: event.target.value
                                      })
                                    }
                                  >
                                    <option value="0">No Max</option>
                                    <option value="750">750 sqft</option>
                                    <option value="1000">1,000 sqft</option>
                                    <option value="1250">1,250 sqft</option>
                                    <option value="1500">1,500 sqft</option>
                                    <option value="1750">1,750 sqft</option>
                                    <option value="2000">2,000 sqft</option>
                                    <option value="2250">2,250 sqft</option>
                                    <option value="2500">2,500 sqft</option>
                                    <option value="2750">2,750 sqft</option>
                                    <option value="3000">3,000 sqft</option>
                                    <option value="3250">3,250 sqft</option>
                                    <option value="3500">3,500 sqft</option>
                                    <option value="3750">3,750 sqft</option>
                                    <option value="5000">5,000 sqft</option>
                                    <option value="7500">7,500 sqft</option>
                                  </select>
                                </div>
                              </div>
                              <div className="rangeSelections row pt-2">
                                <div className="col-12 text-left">
                                  Year Built
                                </div>
                                <div className="col-12">
                                  <input
                                    name="yearMin"
                                    className={`${classes.rangeInput} form-control col-5 d-inline`}
                                    value={listingFilter.yearMin || ""}
                                    onChange={e =>
                                      handleChange(e.target.value, "yearMin")
                                    }
                                    onBlur={event =>
                                      updateFilter({
                                        yearMin: event.target.value
                                      })
                                    }
                                  />
                                  <span className="separator">to</span>
                                  <input
                                    name="yearMax"
                                    className={`${classes.rangeInput} form-control col-5 d-inline`}
                                    value={listingFilter.yearMax || ""}
                                    onChange={e =>
                                      handleChange(e.target.value, "yearMax")
                                    }
                                    onBlur={event =>
                                      updateFilter({
                                        yearMax: event.target.value
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="rangeSelections row pt-2">
                                <div className="col-12 text-left">Acreage</div>
                                <div className="col-12">
                                  <input
                                    name="acreageMin"
                                    className={`${classes.rangeInput} form-control col-5 d-inline`}
                                    value={listingFilter.acreageMin || ""}
                                    onChange={e =>
                                      handleChange(e.target.value, "acreageMin")
                                    }
                                    onBlur={event =>
                                      updateFilter({
                                        acreageMin: event.target.value
                                      })
                                    }
                                  />
                                  <span className="separator">to</span>
                                  <input
                                    name="acreageMax"
                                    className={`${classes.rangeInput} form-control col-5 d-inline`}
                                    value={listingFilter.acreageMax || ""}
                                    onChange={e =>
                                      handleChange(e.target.value, "acreageMax")
                                    }
                                    onBlur={event =>
                                      updateFilter({
                                        acreageMax: event.target.value
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row pt-2 rangeSelections">
                                <div className="col-12 text-left">
                                  Neighborhood
                                </div>
                                <div className="col-12">
                                  <select
                                    name="MLSAreas"
                                    className="select custom-select range-select col-10"
                                    value={listingFilter.MLSAreas}
                                    onChange={event =>
                                      updateFilter({
                                        MLSAreas: event.target.value
                                      })
                                    }
                                  >
                                    <option value="">Any</option>
                                    <option value="94,95,96">Arlington</option>
                                    <option value="94">
                                      Arlington Reserve
                                    </option>
                                    <option value="97,98,99,100,101,102">
                                      Bartlett
                                    </option>
                                    <option value="102,99,97">
                                      Bartlett Reserve
                                    </option>
                                    <option value="74,75,76,77,78,79,80,81,82">
                                      Cordova
                                    </option>
                                    <option value="107,108,109,110,111,112">
                                      Collierville
                                    </option>
                                    <option value="107,72,24">
                                      Collierville Reserve
                                    </option>
                                    <option value="36,40,42">Downtown</option>
                                    <option value="47,48,49,50,51,52,44,45,46,65,66,67">
                                      East Memphis
                                    </option>
                                    <option value="24,25,26,27,28,29,30">
                                      Frayser
                                    </option>
                                    <option value="103,104,105,106,71,67,65">
                                      Germantown
                                    </option>
                                    <option value="91,92,93">Lakeland</option>
                                    <option value="92">Lakeland Reserve</option>
                                    <option value="37,38,39,41,43">
                                      Midtown
                                    </option>
                                    <option value="83,84,85,86,87,88,89,90">
                                      Millington
                                    </option>
                                    <option value="31,32,33,34,35">
                                      Raleigh
                                    </option>
                                    <option value="113,8,9,10,11,12,13,14,15,5,1,2,3,4,6,7,16,17,18,19,20,21,22,23">
                                      Rural
                                    </option>
                                    <option value="72,68,69,70,71,73,61,62,63,64">
                                      Southwind
                                    </option>
                                    <option value="53,54,55,56,57,58,59,60">
                                      Whitehaven
                                    </option>
                                  </select>
                                </div>
                              </div>

                              <div className="row pt-2 rangeSelections">
                                <div className="col-12 text-left">Pool</div>
                                <div className="col-12">
                                  <select
                                    name="pool"
                                    className="select custom-select range-select col-10"
                                    value={listingFilter.pool}
                                    onChange={event =>
                                      updateFilter({ pool: event.target.value })
                                    }
                                  >
                                    <option value="">Any</option>
                                    <option value="NBRHD">Neighborhood</option>
                                    <option value="INGRD">Inground</option>
                                    <option value="ABVGR">Above Ground</option>
                                  </select>
                                </div>
                              </div>
                              <div className="form-check form-check-inline pt-2 justify-content-start d-block">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" New Construction"
                                  checked={listingFilter.newConstruction}
                                  onChange={(e, checked) =>
                                    updateFilter({
                                      newConstruction: checked ? 1 : 0
                                    })
                                  }
                                />
                              </div>
                              <div className="form-check form-check-inline pt-2 justify-content-start">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Guest House/In-Law Quarters"
                                  checked={listingFilter.guestHouse}
                                  onChange={(e, checked) =>
                                    updateFilter({
                                      guestHouse: checked ? 1 : 0
                                    })
                                  }
                                />
                              </div>
                              <div className="form-check form-check-inline col pt-2 justify-content-start">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Hobson Listings Only"
                                  checked={listingFilter.hobsonOnly}
                                  onChange={(e, checked) =>
                                    updateFilter({
                                      hobsonOnly: checked ? 1 : 0
                                    })
                                  }
                                />
                              </div>
                              <div className="form-check form-check-inline col pt-2 justify-content-start">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Master Bed Down"
                                  checked={listingFilter.masterBedDown}
                                  onChange={(e, checked) =>
                                    updateFilter({
                                      masterBedDown: checked ? 1 : 0
                                    })
                                  }
                                />
                              </div>
                              <div className="form-check form-check-inline col pt-2 justify-content-start">
                                <Checkbox
                                  checkboxClass="icheckbox_flat-blue"
                                  increaseArea="20%"
                                  label=" Has Open House"
                                  checked={listingFilter.hasOpenHouse}
                                  onChange={(e, checked) =>
                                    updateFilter({
                                      hasOpenHouse: checked ? 1 : 0
                                    })
                                  }
                                />
                              </div>

                              <div
                                className="col-12 pt-2"
                                style={{ paddingLeft: "0" }}
                              >
                                <label
                                  htmlFor="daysOnMarket"
                                  className="col-form-label col-xl-3 col-md-5 pl-0 pr-0"
                                >
                                  Days on Market
                                  <select
                                    id="daysOnMarket"
                                    name="daysOnMarket"
                                    className="select custom-select col-8"
                                    style={{ display: "block" }}
                                    value={listingFilter.daysOnMarketStr}
                                    onChange={event =>
                                      updateFilter({
                                        daysOnMarketStr: event.target.value
                                      })
                                    }
                                  >
                                    <option value="">Any</option>
                                    <option value="24h">Last 24 hours</option>
                                    <option value="1w">Within last week</option>
                                    <option value="1m">
                                      Within last month
                                    </option>
                                    <option value="3m">
                                      Within last 3 month
                                    </option>
                                    <option value="46m">4 to 6 months</option>
                                    <option value="6m">6+ months</option>
                                  </select>
                                </label>
                              </div>
                              <div
                                className="col-12"
                                style={{ paddingLeft: "0" }}
                              >
                                <label
                                  htmlFor="coveredParking"
                                  className="col-form-label col-sm-6 col-xl-3 col-md-4 pl-0 pr-0"
                                >
                                  Covered Parking
                                  <select
                                    id="coveredParking"
                                    className="custom-select mr-sm-2 col-4"
                                    style={{ width: "100%", display: "block" }}
                                    name="coveredParking"
                                    value={listingFilter.coveredParking}
                                    onChange={event =>
                                      updateFilter({
                                        coveredParking: event.target.value
                                      })
                                    }
                                  >
                                    <option>Any</option>
                                    <option value="1">1+</option>
                                    <option value="2">2+</option>
                                    <option value="3">3+</option>
                                    <option value="4">4+</option>
                                  </select>
                                </label>
                              </div>
                              <div
                                className="col-12"
                                style={{ paddingLeft: "0" }}
                              >
                                <label className="col-form-label col-sm-6 col-xl-3 col-md-4 pl-0 pr-0">
                                  Status
                                </label>
                                <div className="col-12 px-2">
                                  <div className="form-check form-check-inline">
                                    <Checkbox
                                      checkboxClass="icheckbox_flat-blue"
                                      increaseArea="20%"
                                      label=" Active"
                                      checked={
                                        listingFilter.status &&
                                        listingFilter.status.indexOf("ACT") > -1
                                      }
                                      onChange={(e, checked) =>
                                        handleStatusChange(e, checked, "ACT")
                                      }
                                    />
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <Checkbox
                                      checkboxClass="icheckbox_flat-blue"
                                      increaseArea="20%"
                                      label=" Contingent"
                                      checked={
                                        listingFilter.status &&
                                        listingFilter.status.indexOf("CNTG") >
                                          -1
                                      }
                                      onChange={(e, checked) =>
                                        handleStatusChange(e, checked, "CNTG")
                                      }
                                    />
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <Checkbox
                                      checkboxClass="icheckbox_flat-blue"
                                      increaseArea="20%"
                                      label=" Pending"
                                      checked={
                                        listingFilter.status &&
                                        listingFilter.status.indexOf("PEND") >
                                          -1
                                      }
                                      onChange={(e, checked) =>
                                        handleStatusChange(e, checked, "PEND")
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="col-12 pt-2">
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      data-dismiss="modal"
                    >
                      View {listings.length} Listings
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger w-100 mt-2"
                      onClick={() => clearFilter()}
                      data-dismiss="modal"
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}

export default withStyles(styles)(MobileSearch);
